import React, { type FC, useState } from 'react'
import { IconButton } from 'components/buttons/IconButton/IconButton'
import { BackArrowIcon } from 'assets/icons/BackArrowIcon'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import { Tooltip, TooltipTheme } from 'components/Tooltip/Tooltip'
import { t } from '@lingui/macro'

import styles from './TopActionsBar.module.scss'

export const TopActionsBar: FC = () => {
  const hideMoreOptionsTooltip = 'hideMoreOptionsTooltip'

  const [showMoreOptionsToolTip, setShowMoreOptionsToolTip] = useState(
    !localStorage.getItem(hideMoreOptionsTooltip)
  )

  const history = useHistory()

  const handleOnBackClick = () => {
    history.goBack()
  }

  const handleOnConfirmTooltipClick = () => {
    localStorage.setItem(hideMoreOptionsTooltip, 'true')
    setShowMoreOptionsToolTip(false)
  }
  return (
    <div className={classNames(styles.TopActionsBar)}>
      <IconButton
        id={'back-arrow-button'}
        customStyle={styles.BackButton}
        onClick={handleOnBackClick}
      >
        <BackArrowIcon />
      </IconButton>
      <div className={styles.RightContainer}>
        <div className={styles.StreamOptionsButton}>
          {showMoreOptionsToolTip && (
            <div className={styles.OptionsTooltipWrapper}>
              <Tooltip
                title={t`Helpfull tip!`}
                text={t`Here you can find more options for the stream.`}
                position="Bottom"
                pointerPosition="Right"
                confirmButtonText={t`Got it`}
                onConfirmButtonClick={handleOnConfirmTooltipClick}
                theme={TooltipTheme.Light}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
